import React from "react";

import ListItemText from "@material-ui/core/ListItemText";
import * as styles from "../newStyles.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { css } from "react-emotion";
// import Flickity from "react-flickity-component";

const gridStyle = css`
  margin-top: 30px;
  width: 100%;
  outline: none;
  display: -ms-grid;
  display: grid;
  grid-gap: 25px;
  -ms-grid-columns: 100%;
  grid-template-columns: 100%;
  @media (min-width: 31.3125em) {
    -ms-grid-columns: (calc(50% - 12.5px));
    grid-template-columns: repeat(2, calc(50% - 12.5px));
  }
  @media (min-width: 48.0625em) {
    -ms-grid-columns: (calc(25% - 30px));
    grid-template-columns: repeat(4, calc(25% - 30px));
    grid-gap: 40px;
  }
`;

const flickityStyle = css`
  height: 171px;
  touch-action: pan-y;
`;
const slider = css`
  left: 0px;
`;
const flickityContainer = css`
  position: absolute;
  left: 0%;

  @media (max-width: 31.3025em) {
    width: 65%;
    padding: 0 5%;
    margin: 0 auto;
    cursor: move;
    cursor: grab;
    cursor: -webkit-grab;
  }
`;

const listItemStyle = css`
  text-align: center;
  -webkit-column-break-inside: avoid;
  -moz-column-break-inside: avoid;
  break-inside: avoid;
`;

const listItemSmall = css`
  @media (max-width: 48.0525em) {
    max-width: 420px;
    margin: auto;
  }
`;

const icon = css`
  font-size: 36px;
  width: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
  color: #89d2d3;
`;

const currentFeatures = [
  {
    title: "Push Notifications",
    desc: "Use push notifications to actively engage your customers and stay top of their mind.",
    icon: "bell",
  },

  {
    title: "Deals and Offers",
    desc: "Provide exclusive, rotating offers and deals through your mobile app to keep customers checking in consistently.",
    icon: "business-time",
  },
  {
    title: "Mobile Store",
    desc: "Sell products directly through your mobile app and streamline your ordering process. Set up pickup, delivery, and shipping options.",
    icon: "hand-holding-usd",
  },
  {
    title: "Grocery Store Ordering",
    desc: "Leverage curbside ordering to allow customers to make a grocery list. Pack their items, process payment through the app, and off they go.",
    icon: "shopping-basket",
  },
  {
    title: "Rewards",
    desc: "Set up a rewards system that converts an average customer into a loyal one. Keep them coming back for more!",
    icon: "star",
  },
  {
    title: "Analytics",
    desc: "Leverage app analytics and customer insights like a pro to improve your customer experience.",
    icon: "chart-line",
  },
  {
    title: "Partner Integrations",
    desc: "Existing integrations like (DoorDash, ToastTab, UberEats, etc) can be loaded directly into your app!",
    icon: "handshake",
  },
  {
    title: "Website Integration",
    desc: "Have a specific website you want to reuse? Integrate any website directly into your mobile app in 15 seconds.",
    icon: "wifi",
  },
];

export default function CurrentFeatures(props) {
  const { noTitle } = props;
  const renderFeatures = () => {
    return (
      <div style={{ margin: "auto" }}>
        {/* <div>
          <Flickity
            className={flickityStyle} // default ''
            elementType={"div"} // default 'div'
            // options={flickityOptions} // takes flickity options {}
            disableImagesLoaded={false} // default false
            reloadOnUpdate // default false
            static // default false
          >
            {currentFeatures.map((feature) => {
              return (
                <div className={listItemStyle + " " + listItemSmall}>
                  <FontAwesomeIcon icon={feature.icon} className={icon} />
                  <ListItemText
                    primary={feature.title}
                    style={{ fontWeight: "bold" }}
                  />
                  <p style={{ fontSize: "14px" }}>{feature.desc}</p>
                </div>
              );
            })}
          </Flickity>
        </div> */}
        <div className={gridStyle}>
          {currentFeatures.map((feature) => {
            return (
              <div
                className={listItemStyle + " " + listItemSmall}
                key={feature.title}
              >
                <FontAwesomeIcon icon={feature.icon} className={icon} />

                <h2 className={styles.innerH2} style={{ textAlign: "center" }}>
                  {feature.title}
                </h2>
                <p className={styles.innerParagraph}>{feature.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.row}>
      <div
        style={{
          maxWidth: "1000px",
          margin: "auto",
          display: "flex",
          flexFlow: "row wrap",
        }}
      >
        <styles.H2
          style={{
            textAlign: "center",
            margin: "30px",
            width: "100%",
            marginTop: noTitle ? "0px" : "60px",
          }}
        >
          Current <span className={styles.styledUnderline}>Features</span>
        </styles.H2>

        {renderFeatures()}
        <div style={{ marginTop: "30px" }}>
          <div className={listItemStyle}>
            <div>
              <FontAwesomeIcon icon={"plus-circle"} className={icon} />
            </div>
            <h2 className={styles.innerH2} style={{ textAlign: "center" }}>
              So Many More to Come!
            </h2>
            <p className={styles.innerParagraph}>
              At Mobile360, we are continuously evolving and enhancing the
              platform by adding new features and keeping the platform up to
              date. Have a specific feature in mind? Contact us and we'll do our
              best to build it for you - for free!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
